exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".label-bold-center[data-v-0f67f5b6]{display:inline-flex;align-items:center;justify-content:center;font-weight:800;color:#000;border:none;background:transparent;width:100%;min-height:30px}.info-grid[data-v-0f67f5b6]{display:grid;grid-template-columns:repeat(auto-fit,minmax(300px,1fr));gap:20px;margin-top:20px}.info-field[data-v-0f67f5b6]{display:flex;flex-direction:column}.table td[data-v-0f67f5b6]{padding:4px!important;vertical-align:middle}.table-input[data-v-0f67f5b6]{width:100%;height:30px;padding:2px 6px;margin:0;box-sizing:border-box;border:1px solid #ccc;border-radius:4px;font-size:13px}.info-input[data-v-0f67f5b6]{padding:8px;border:1px solid #ccc;border-radius:4px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0f67f5b6","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/ims/DirectorInfo.vue
// module id = 155
// module chunks = 0